import { render, staticRenderFns } from "./HouseInfo.vue?vue&type=template&id=060de973&scoped=true&"
import script from "./HouseInfo.vue?vue&type=script&lang=js&"
export * from "./HouseInfo.vue?vue&type=script&lang=js&"
import style0 from "./HouseInfo.vue?vue&type=style&index=0&id=060de973&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060de973",
  null
  
)

export default component.exports